import { ItemPickerModel } from 'src/app/shared/components/item-picker/models/itemPickerModel';

export enum PaymentRecordsReportFields {
  id = 'id',
  feeDefinitionId = 'feeDefinitionId',
  personInvoiceId = 'personInvoiceId',
  invoiceStatus = 'invoiceStatus',
  firstName = 'firstName',
  lastName = 'lastName',
  fullName = 'fullName',
  suffix = 'suffix',
  orderNumber = 'orderNumber',
  ledgerCode = 'ledgerCode',
  credentialDefinitionId = 'credentialDefinitionId',
  personCredentialId = 'personCredentialId',
  applicationDefinitionId = 'applicationDefinitionId',
  personScenarioId = 'personScenarioId',
  credentialApplicationNumber = 'credentialApplicationNumber',
  credentialName = 'credentialName',
  credentialApplicationType = 'credentialApplicationType',
  lineItemDescription = 'lineItemDescription',
  amount = 'amount',
  transactionDate = 'transactionDate',
  completionDate = 'completionDate',
  paymentType = 'paymentType',
  creditCardType = 'creditCardType',
  creditCardLastFour = 'creditCardLastFour',
  nameOnCheck = 'nameOnCheck',
  checkNumber = 'checkNumber',
}

export const PaymentRecordsReportSystemColumns: ItemPickerModel[] = [
  new ItemPickerModel(PaymentRecordsReportFields.firstName, '', 'First Name'),
  new ItemPickerModel(PaymentRecordsReportFields.lastName, '', 'Last Name'),
  new ItemPickerModel(PaymentRecordsReportFields.fullName, '', 'Full Name'),
  new ItemPickerModel(PaymentRecordsReportFields.suffix, '', 'Suffix'),
  new ItemPickerModel(PaymentRecordsReportFields.orderNumber, '', 'Order Number'),
  new ItemPickerModel(PaymentRecordsReportFields.ledgerCode, '', 'Ledger Code'),
  new ItemPickerModel(PaymentRecordsReportFields.lineItemDescription, '', 'Line Item Description'),
  new ItemPickerModel(PaymentRecordsReportFields.amount, '', 'Amount'),
  new ItemPickerModel(PaymentRecordsReportFields.transactionDate, '', 'Transaction Date'),
  new ItemPickerModel(PaymentRecordsReportFields.completionDate, '', 'Completion Date'),
  new ItemPickerModel(PaymentRecordsReportFields.paymentType, '', 'Payment Type'),
  new ItemPickerModel(PaymentRecordsReportFields.creditCardType, '', 'Credit Card Type'),
  new ItemPickerModel(
    PaymentRecordsReportFields.creditCardLastFour,
    '',
    'Credit Card Last 4 Digits'
  ),
  new ItemPickerModel(PaymentRecordsReportFields.nameOnCheck, '', 'Name on Check'),
  new ItemPickerModel(PaymentRecordsReportFields.checkNumber, '', 'Check Number'),
];

export const CredentialPaymentRecordsReportSystemColumns: ItemPickerModel[] = [
  ...PaymentRecordsReportSystemColumns,
  new ItemPickerModel(PaymentRecordsReportFields.credentialName, '', 'Credential'),
  new ItemPickerModel(PaymentRecordsReportFields.credentialApplicationType, '', 'Application Type'),
  new ItemPickerModel(
    PaymentRecordsReportFields.credentialApplicationNumber,
    '',
    'Application Number'
  ),
];
